module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.sidebarClasses,
    staticStyle: {
      "background-image": "url(static/img/sidebar-1.jpg)"
    },
    attrs: {
      "data-color": _vm.backgroundColor,
      "data-image": "static/img/sidebar-1.jpg",
      "data-active-color": _vm.activeColor
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "sidebar-wrapper"
  }, [_vm._t("default"), _vm._v(" "), _c('ul', {
    staticClass: "nav nav-mobile-menu"
  }, [_vm._m(1), _vm._v(" "), _c('drop-down', [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "data-toggle": "dropdown"
    },
    slot: "title"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("notifications")]), _vm._v(" "), _c('span', {
    staticClass: "notification"
  }, [_vm._v("5")]), _vm._v(" "), _c('p', {
    staticClass: "hidden-lg hidden-md"
  }, [_vm._v("Notifications")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Mike John responded to your email")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("You have 5 new tasks")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("You're now friend with Andrew")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Another Notification")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Another One")])])]), _vm._v(" "), _vm._m(2)], 1), _vm._v(" "), _c('ul', {
    class: _vm.navClasses
  }, _vm._l((_vm.sidebarLinks), function(link, index) {
    return _c('router-link', {
      ref: link.name,
      refInFor: true,
      attrs: {
        "to": link.path,
        "tag": "li"
      }
    }, [_c('a', [(link.icon) ? _c('i', {
      staticClass: "material-icons"
    }, [_vm._v(_vm._s(link.icon))]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v(_vm._s(link.name) + "\n          ")])])])
  }))], 2), _vm._v(" "), _c('div', {
    staticClass: "sidebar-background",
    staticStyle: {
      "background-image": "url(static/img/sidebar-1.jpg)"
    }
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo"
  }, [_c('a', {
    staticClass: "simple-text",
    attrs: {
      "href": "http://www.creative-tim.com"
    }
  }, [_vm._v("\n      Creative Tim\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    staticClass: "dropdown-toggle active",
    attrs: {
      "href": "#/",
      "data-toggle": "dropdown"
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("dashboard")]), _vm._v(" "), _c('p', {
    staticClass: "hidden-lg hidden-md"
  }, [_vm._v("Dashboard")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "#",
      "data-toggle": "dropdown"
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("person")]), _vm._v(" "), _c('p', {
    staticClass: "hidden-lg hidden-md"
  }, [_vm._v("Profile")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3151bd59!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UIComponents/SidebarPlugin/SideBar.vue
// module id = 158
// module chunks = 2